import { render } from "./LoadStandards.vue?vue&type=template&id=0452373f&scoped=true&ts=true"
import script from "./LoadStandards.vue?vue&type=script&lang=ts"
export * from "./LoadStandards.vue?vue&type=script&lang=ts"

import "./LoadStandards.vue?vue&type=style&index=0&id=0452373f&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0452373f"]])

export default __exports__